import Backbone from 'backbone';
import ResponsesCollection from 'ef/collections/responses_collection';
import Response from 'ef/models/response';
import _ from 'lodash';

const ResponseSet = Backbone.Model.extend({
  initialize: function (attrs, options) {
    this.parse(attrs);
    this.survey = options.survey;
    this.responses = new ResponsesCollection([], {
      response_set: this,
    });
  },

  url: function () {
    const base = `${this.survey.url().replace('.json', '')}/response_sets.json`;
    if (this.isNew()) {
      return base;
    }
    return `${
      base.replace('.json', '') + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id)
    }.json`;
  },

  parse: function (json) {
    this.responses = new ResponsesCollection(json.responses, {
      response_set: this,
    });
    delete json.responses;
    return json;
  },

  // Recored a user's answer to a question. Takes an optional success callback
  // in the options hash
  answerQuestion: function (question_id, answer_id, options) {
    return this.answerQuestions([{ question_id: question_id, answer_id: answer_id }], options)[0];
  },

  // Record a user's answers to multiple questions. Takes an optional success callback
  // in the options hash
  answerQuestions: function (responses, options) {
    options = options || {};
    const resps = _.map(responses, function (r) {
      return new Response({
        question_id: r.question_id,
        answer_id: r.answer_id,
      });
    });
    this.responses.add(resps);

    const rc = new ResponsesCollection(resps, {
      response_set: this,
    });
    rc.sync('create', rc, options);

    return resps;
  },

  // retrieve the user's answer for a question by question_name
  responseForQuestionByName: function (question_name) {
    const responses = this.responses.filter(function (resp) {
      return resp.get('question_name') === question_name;
    });
    return responses[responses.length - 1]; // Grab the latest response;
  },

  // retrieve the user's answer for a question by question_id
  responseForQuestionById: function (question_id) {
    const responses = this.responses.filter(function (resp) {
      return resp.get('question_id') === question_id;
    });
    return responses[responses.length - 1]; // Grab the latest response;
  },

  unAnswerQuestion: function (question_id, answer_id) {
    return this.unAnswerQuestions([{ question_id: question_id, answer_id: answer_id }])[0];
  },

  unAnswerQuestions: function (responses, options) {
    options = options || {};
    const resps = _.map(responses, function (r, idx) {
      return new Response({
        id: idx,
        question_id: r.question_id,
        answer_id: r.answer_id,
      });
    });

    const rc = new ResponsesCollection(resps, {
      response_set: this,
    });
    const self = this;
    rc.sync('delete', rc, {
      success: function () {
        const deleted_responses = self.responses.filter(function (delresp) {
          return _.find(resps, function (resp) {
            return (
              resp.get('question_id') === delresp.get('question_id') &&
              resp.get('answer_id') === delresp.get('answer_id')
            );
          });
        });
        self.responses.remove(deleted_responses);

        if (options && options.success) {
          options.success(resps);
        }
      },
    });
    return resps;
  },
});

export default ResponseSet;
